"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var adyenTranslations = {
  'en-US': {
    'creditCard.holderName.invalid': 'Cardholder name is not valid',
    'error.va.sf-cc-dat.01': 'Expiry date is in the past'
  }
};
var _default = adyenTranslations;
exports.default = _default;